// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"common_IconButton__aKF5Z","CloseDialogButton":"common_CloseDialogButton__pmLBD","DialogContent":"common_DialogContent__FWYdS"};